var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('Tabs', {
    on: {
      "on-click": _vm.onClickTab
    }
  }, [_c('TabPane', {
    attrs: {
      "label": $t("eb8e2", "公告"),
      "icon": "ios-megaphone",
      "name": "NOTICE"
    }
  }), _c('TabPane', {
    attrs: {
      "label": $t("gjaj2", "广告"),
      "icon": "ios-photos",
      "name": "ADVERT"
    }
  })], 1), _c('pro-table', _vm._b({}, 'pro-table', _vm.config, false))], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };